import {
    SiAdobexd,
    SiAndroid,
    SiApple,
    SiCss3,
    SiExpress,
    SiFacebook,
    SiFirebase,
    SiFlutter,
    SiGit,
    SiGithub,
    SiGithubactions,
    SiGoogleads,
    SiGoogleanalytics,
    SiGooglesearchconsole,
    SiGoogletagmanager,
    SiHtml5,
    SiJira,
    SiKubernetes,
    SiMicrosoftazure,
    SiMongodb,
    SiMysql,
    SiNestjs,
    SiNextdotjs,
    SiNginx,
    SiPostgresql,
    SiRedis,
    SiRedux,
    SiSketch,
    SiTailwindcss,
    SiTypescript,
    SiVite,
} from "react-icons/si";

import {
    FaAws,
    FaDocker,
    FaFigma,
    FaGoogle,
    FaNodeJs,
    FaReact,
} from "react-icons/fa";

const techStackData = [
  {
    category: "Frontend",
    techs: [
      { icon: <FaReact />, name: "React" },
      { icon: <SiNextdotjs />, name: "Next.js" },
      { icon: <SiTypescript />, name: "TypeScript" },
      { icon: <SiTailwindcss />, name: "Tailwind CSS" },
      { icon: <SiRedux />, name: "Redux" },
      { icon: <SiVite />, name: "Vite" },
      { icon: <SiHtml5 />, name: "HTML5" },
      { icon: <SiCss3 />, name: "CSS3" },
    ],
  },

  {
    category: "Backend",
    techs: [
      { icon: <FaNodeJs />, name: "Node.js" },
      { icon: <SiExpress />, name: "Express.js" },
      { icon: <SiNestjs />, name: "NestJS" },
      { icon: <SiPostgresql />, name: "PostgreSQL" },
      { icon: <SiMongodb />, name: "MongoDB" },
      { icon: <SiMysql />, name: "MySQL" },
      { icon: <SiFirebase />, name: "Firebase" },
      { icon: <SiRedis />, name: "Redis" },
    ],
  },

  {
    category: "Cloud & DevOps",
    techs: [
      { icon: <FaAws />, name: "AWS" },
      { icon: <FaGoogle />, name: "Google Cloud" },
      { icon: <SiMicrosoftazure />, name: "Azure" },
      { icon: <FaDocker />, name: "Docker" },
      { icon: <SiKubernetes />, name: "Kubernetes" },
      { icon: <SiNginx />, name: "Nginx" },
      { icon: <SiGithubactions />, name: "GitHub Actions" },
    ],
  },

  {
    category: "Mobile",
    techs: [
      { icon: <FaReact />, name: "React Native" },
      { icon: <SiFlutter />, name: "Flutter" },
      { icon: <SiAndroid />, name: "Android" },
      { icon: <SiApple />, name: "iOS" },
    ],
  },

  {
    category: "Design & Tools",
    techs: [
      { icon: <FaFigma />, name: "Figma" },
      { icon: <SiAdobexd />, name: "Adobe XD" },
      { icon: <SiSketch />, name: "Sketch" },
      { icon: <SiJira />, name: "Jira" },
      { icon: <SiGithub />, name: "GitHub" },
      { icon: <SiGit />, name: "Git" },
    ],
  },

  {
    category: "Marketing & Analytics",
    techs: [
      { icon: <SiGoogleanalytics />, name: "Google Analytics" },
      { icon: <SiGoogletagmanager />, name: "Tag Manager" },
      { icon: <SiGoogleads />, name: "Google Ads" },
      { icon: <SiFacebook />, name: "Meta Ads" },
      { icon: <SiGooglesearchconsole />, name: "SEO Tools" },
    ],
  },
];


export default techStackData;